const Bloodhound = require('typeahead.js');

function abbrv_number(value) {
  const suffixes = ['', 'k', 'm', 'b', 't'];
  let suffix = 0;
  for (; value >= 1000; ++suffix) {
    value /= 1000;
  }
  value = Math.floor(value);
  value += suffixes[suffix];
  return value;
}
function* short_prices() {
  for (let first_digit = 1; first_digit <= 9; ++first_digit) {
    for (let num_zeros = 5; num_zeros <= 7; ++num_zeros) {
      const value = first_digit * Math.pow(10, num_zeros);
      yield abbrv_number(value);
    }
  }
}

export function initalize() {
  const propertyLocation = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    prefetch: '/autocomplete',
    remote: {
      url: '/autocomplete/%QUERY',
      wildcard: '%QUERY',
    }
  });
  $('#search-where').typeahead(null, {
    name: 'property-location',
    source: propertyLocation,
    async: true,
    highlight: true,
    hint: true,
    minLength: 1,
  });

  // const prices = new Bloodhound({
  //   datumTokenizer: Bloodhound.tokenizers.whitespace,
  //   queryTokenizer: Bloodhound.tokenizers.whitespace,
  //   local: Array.from(short_prices()),
  // });
  // $('#search-min-price, #search-max-price').typeahead(null, {
  //   name: 'property-price',
  //   source: prices,
  //   limit: 2,
  //   highlight: true,
  //   hint: true,
  //   minLength: 1,
  // });
}
